import System from "src/helper/system";
import HCLDX from "./hcldx";

class Profile {
    static PROFILE_ACCOUNT_INFORMATION = System.getProfileUrl() + '/api/user/amer/profile';
    static SET_CONTACT_INFORMATION = System.getAdminConsoleUrl() + '/api/admin/edituser';
    static GET_JOBFUNCTION_LIST = System.getApplicationUrl() + '/api/application/reference/all/Jobfunction';
    static HEADER_ACCOUNT_LIST = System.getProfileUrl() + '/api/user/current/account';
    static ADD_PROFILE_ADDRESS_URL = System.getBaseUrl() + `/api/user/amer/shippingAddress`;
    static VALIDATE_PROFILE_ADDRESS = System.getBaseUrl() + `/api/user/shipping/validation`;
    static GET_COUNTRY_LIST = System.getBaseUrl() + `/api/reference/countryData`;
    static GET_CARRIER_DATA_LIST = System.getBaseUrl() + `/api/reference/carrierData`;
    static GET_STATE_LIST = System.getBaseUrl() + `/api/reference/statesData`;
    static SET_ACCOUNT_LINK_INFORMATION = System.getProfileUrl() + '/api/user/amer/sendEmailToLinkExistingAccount';
    static CHEK_VALID_ACCOUNT = System.getProfileUrl() + '/api/user/checkAccountnumberExists';

    static getProfileURL() {
        return HCLDX.baseURL() + "/resources/myavnet/profile";
      }

    static getLinkToExistingAccountURL() {
      return HCLDX.baseURL() + "/resources/myavnet/link-to-existing-account";
    }
}

export default Profile;